// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"d9502332","239":"a8edb71a","453":"2c56e9b8","563":"446ad991","977":"028e02a6"}[chunkId] + ".chunk.js";
};